import BottomButton from './bottom-button';
import './styles/index.scss';
export default BottomButton;
